export default "__VITE_ASSET__BYhsvDa9__"